import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import { get } from 'lodash';

function coerceItemToArray(item) {
  var _context;

  return !_Array$isArray(item) ? _filterInstanceProperty(_context = [item]).call(_context, Boolean) : item;
}

function safeGetId(item) {
  return get(item, 'value.id', get(item, 'value'));
}

export { coerceItemToArray, safeGetId };